module.exports = __webpack_public_path__ + "img/7.103c0884.jpg";